
import React from 'react';
import { usePersonaContext } from '@/contexts/PersonaContext';
import { AppNavbar } from '@/components/layout/AppNavbar';
import { ReviewerMetricsCards } from '@/components/reviewer/ReviewerMetricsCards';
import { AssignedReviewsList } from '@/components/reviewer/AssignedReviewsList';
import { ActivityFeed } from '@/components/reviewer/ActivityFeed';

// Mock data - will be replaced with real data from API
const mockMetrics = {
  avgTurnaroundDays: 45,
  targetTurnaroundDays: 60,
  avgReviewHours: 28,
  targetReviewHours: 32,
  completedReviews: 24,
  onTimeReviews: 22,
};

const mockReviews = [
  {
    id: '1',
    projectTitle: 'GreenClean Floor Cleaner Certification',
    clientName: 'EcoProducts Inc.',
    status: 'in_progress' as const,
    daysRemaining: 12,
    submittedDate: '2024-01-15',
    targetCompletionDate: '2024-03-15',
    priority: 'high' as const,
  },
  {
    id: '2',
    projectTitle: 'SafeGuard Disinfectant Review',
    clientName: 'CleanTech Solutions',
    status: 'pending' as const,
    daysRemaining: 28,
    submittedDate: '2024-01-20',
    targetCompletionDate: '2024-03-20',
    priority: 'medium' as const,
  },
  {
    id: '3',
    projectTitle: 'BioClean Multi-Surface Cleaner',
    clientName: 'Natural Products LLC',
    status: 'overdue' as const,
    daysRemaining: -3,
    submittedDate: '2023-12-01',
    targetCompletionDate: '2024-01-30',
    priority: 'high' as const,
  },
];

const mockActivities = [
  {
    id: '1',
    type: 'message' as const,
    title: 'New message from client',
    description: 'Client requested clarification on formula disclosure requirements',
    timestamp: '2 hours ago',
    user: { name: 'Sarah Johnson', role: 'client' as const },
    projectTitle: 'GreenClean Floor Cleaner',
    priority: 'medium' as const,
  },
  {
    id: '2',
    type: 'document' as const,
    title: 'Updated SDS document uploaded',
    description: 'Client uploaded revised Safety Data Sheet with additional testing data',
    timestamp: '4 hours ago',
    user: { name: 'Mike Chen', role: 'client' as const },
    projectTitle: 'SafeGuard Disinfectant',
  },
  {
    id: '3',
    type: 'status_change' as const,
    title: 'Review status updated',
    description: 'Internal team marked preliminary review as completed',
    timestamp: '1 day ago',
    user: { name: 'Lisa Wong', role: 'internal' as const },
    projectTitle: 'BioClean Multi-Surface',
  },
  {
    id: '4',
    type: 'deadline' as const,
    title: 'Approaching deadline',
    description: 'Review deadline in 5 days - priority escalation recommended',
    timestamp: '2 days ago',
    user: { name: 'System', role: 'internal' as const },
    projectTitle: 'GreenClean Floor Cleaner',
    priority: 'high' as const,
  },
];

const Reviewer = () => {
  const { currentPersona } = usePersonaContext();
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppNavbar />
      
      <main className="flex-1 container py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Reviewer Dashboard</h1>
          <p className="text-muted-foreground">
            Track your review performance and manage assigned certification packages
          </p>
        </div>

        <ReviewerMetricsCards metrics={mockMetrics} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <AssignedReviewsList reviews={mockReviews} />
          <ActivityFeed activities={mockActivities} />
        </div>
      </main>
    </div>
  );
};

export default Reviewer;
